import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useCarousel } from './useCarousel'
import type { WithClassAsProps } from './interface'
import { cn } from '@/utils/utils'



export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'CarouselContent',
  props: {
    class: {}
  },
  setup(__props: any) {



const props = __props

const { carouselRef, orientation } = useCarousel()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "carouselRef",
    ref: carouselRef,
    class: "overflow-hidden"
  }, [
    _createElementVNode("div", _mergeProps({
      class: 
        _unref(cn)(
          'flex',
          _unref(orientation) === 'horizontal' ? '-ml-4' : '-mt-4 flex-col',
          props.class,
        )
    }, _ctx.$attrs), [
      _renderSlot(_ctx.$slots, "default")
    ], 16)
  ], 512))
}
}

})